// src/utils/auth.js
const KEY = "tcp:identifier";          // new key
const LEGACY = "loginIdentifier";      // old key you used before

// Read once per page load; also hydrates sessionStorage so everything reads the same.
export function getIdentifier() {
  try {
    if (window.__tcpId) return window.__tcpId;

    const ss = sessionStorage.getItem(KEY) || sessionStorage.getItem(LEGACY);
    const ls = localStorage.getItem(KEY)  || localStorage.getItem(LEGACY);

    const id = ss || ls || "";
    if (id) {
      window.__tcpId = id;
      // hydrate this tab so code that reads sessionStorage keeps working
      sessionStorage.setItem(KEY, id);
    }
    return id || null;
  } catch {
    return null;
  }
}

// Call this right after a successful login.
// setIdentifier(emailOrUsername, { remember: true }) will persist across tabs/restarts.
export function setIdentifier(id, { remember = false } = {}) {
  if (!id) return clearIdentifier();
  try {
    window.__tcpId = id;
    sessionStorage.setItem(KEY, id);
    // keep legacy key in sync during migration
    sessionStorage.setItem(LEGACY, id);

    if (remember) {
      localStorage.setItem(KEY, id);
      localStorage.setItem(LEGACY, id);
    } else {
      localStorage.removeItem(KEY);
      localStorage.removeItem(LEGACY);
    }
  } catch {}
  return id;
}

export function clearIdentifier() {
  try {
    delete window.__tcpId;
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(LEGACY);
    localStorage.removeItem(KEY);
    localStorage.removeItem(LEGACY);
  } catch {}
}
